import { getCurrentInstance } from "vue";

export function useStoreCompat() {
  const instance = getCurrentInstance();
  if (!instance) {
    throw new Error("useStoreCompat debe usarse dentro de setup()");
  }

  return instance.proxy.$store;
}
